import { render, staticRenderFns } from "./AlgoliaSearchContainer.vue?vue&type=template&id=5350c4d2"
import script from "./AlgoliaSearchContainer.vue?vue&type=script&lang=js"
export * from "./AlgoliaSearchContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports